import React, {useEffect, useState} from "react";
import "./Greeting.scss";
import {greeting} from "../../portfolio";

export default function Greeting() {
  const slides = greeting.heroSlides || [];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const timer = setInterval(() => {
      setActiveSlide(current => (current + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [slides.length]);

  if (!greeting.displayGreeting || slides.length === 0) {
    return null;
  }

  const slide = slides[activeSlide];
  const totalSlides = String(slides.length).padStart(2, "0");
  const currentSlide = String(activeSlide + 1).padStart(2, "0");

  return (
    <section className="hero-wrap" id="greeting">
      <div className="half-slider-img-wrap" aria-hidden="true">
        <div className="hero-bg-image"></div>
        <div className="hero-overlay"></div>
        <div className="pattern-bg"></div>
      </div>

      <div className="half-bg-dec" aria-hidden="true">
        {Array.from({length: 12}).map((_, index) => (
          <span
            key={index}
            className={index === activeSlide + 4 ? "active-dec" : ""}
          ></span>
        ))}
      </div>

      <div className="hero-decor-numb">
        <span>-17.8292</span>
        <span>31.0522</span>
        <a
          href="https://www.google.com/maps/search/Zimbabwe"
          target="_blank"
          rel="noreferrer"
        >
          Based In Zimbabwe
        </a>
      </div>

      <div className="half-hero-wrap">
        <h1>
          {slide.title}
          <br />
          <span>{slide.lead}</span> {slide.highlight}
        </h1>
        <h4>{slide.tag}</h4>
        <a href="#education" className="hero-start-btn">
          Let's Start
        </a>
      </div>

      <div className="slider-nav-counter">
        <span>{currentSlide}</span>
        <span>/</span>
        <span>{totalSlides}</span>
      </div>

      <div className="hero-slider-dots" aria-label="Hero slides">
        {slides.map((item, index) => (
          <button
            key={item.title}
            className={index === activeSlide ? "active-dot" : ""}
            type="button"
            onClick={() => setActiveSlide(index)}
            aria-label={`Show hero slide ${index + 1}`}
          ></button>
        ))}
      </div>

      <div className="hero-line-dec"></div>

      <div className="scroll-nav-wrap">
        <a className="scroll-down-wrap" href="#education">
          <span className="mousey">
            <span className="scroller"></span>
          </span>
          <span>Scroll Down</span>
        </a>
        <nav className="scroll-nav" aria-label="Section navigation">
          <a href="#greeting">Home</a>
          <a href="#education">About</a>
          <a href="#experience">Resume</a>
          <a href="#projects">Projects</a>
          <a href="#skills">Skills</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </section>
  );
}
